import React from 'react';
import PropTypes from 'prop-types';
import SparkIcon from './SparkIcon';

const CollapseToggle = ({ onClick }) => {
  return (
    <button
      className="ai-assistant-sidebar__collapse-toggle"
      onClick={onClick}
      title="Open AI Assistant"
    >
      <span className="ai-assistant-sidebar__collapse-toggle-mark">
        <SparkIcon size={16} />
      </span>
      AI Assistant
    </button>
  );
};

CollapseToggle.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default CollapseToggle;
